export class Controller {

    /** @ngInject */
    constructor($rootScope, $uibModal) {
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
    }

    $onInit() {
    }

    openLoginModal() {
        this.$rootScope.loginModal =
            this.$uibModal.open({component: 'loginModal'});
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/public/google-info/google-info.controller.js